// extracted by css-extract-rspack-plugin
export default {"linkWrapper":"NewModelOption-module__linkWrapper___Tee8Z","modelTitle":"NewModelOption-module__modelTitle___Hc2zy"};